module.exports = __webpack_public_path__ + "img/credit-one-club-gal-12.be60e52f.jpg";